import { useCallback } from 'react';
export default function useActivityFeedScroll(containerRef) {
    const scrollTo = useCallback((direction = 'bottom') => {
        if (containerRef.current) {
            setTimeout(() => {
                var _a, _b;
                (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
                    top: direction === 'bottom' ? (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.scrollHeight : 0,
                    behavior: 'smooth'
                });
            }, 500);
        }
    }, [containerRef]);
    return {
        scrollToBottom: () => scrollTo('bottom'),
        scrollToTop: () => scrollTo('top')
    };
}
